import type React from 'react';

import { Helmet } from 'react-helmet';

import { getClientConfig } from 'config/clients/client-config';
import { themeV2 } from 'theme/themeV2';

const Head: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { publicAssetsRoute, clientName } = getClientConfig();
  const faviconUrl = `${publicAssetsRoute}/favicon.ico`;

  const primaryColor = themeV2.colors.primary100main.value;
  return (
    <Helmet>
      <link href={faviconUrl} rel="shortcut icon" />
      <link href="/assets/tournament-desk-logo.svg" rel="apple-touch-icon" />
      <link href={faviconUrl} rel="apple-touch-icon-precomposed" sizes="57x57" />
      <link href={faviconUrl} rel="apple-touch-icon-precomposed" sizes="114x114" />
      <link href={faviconUrl} rel="apple-touch-icon-precomposed" sizes="72x72" />
      <link href={faviconUrl} rel="apple-touch-icon-precomposed" sizes="144x144" />
      <link href={faviconUrl} rel="icon" sizes="32x32 48x48" type="image/vnd.microsoft.icon" />
      <link href={`${publicAssetsRoute}/manifest.json`} rel="manifest" />
      <title>{clientName} | Tournament Desk</title>
      <meta content={primaryColor} name="theme-color" />
    </Helmet>
  );
};

export default Head;
